const SLIDE_AND_FADE_IN = 'slideAndFadeIn';
const SLIDE_AND_FADE_OUT = 'slideAndFadeOut';
const FADE_IN = 'fadeIn';
const FADE_OUT = 'fadeOut';
const ENABLE_USER_INPUT = 'enable-user-input';
const DISABLE_USER_INPUT = 'disable-user-input';

export const ANIMATIONS = {
    SLIDE_AND_FADE_IN,
    SLIDE_AND_FADE_OUT,
    FADE_IN,
    FADE_OUT,
    ENABLE_USER_INPUT,
    DISABLE_USER_INPUT
};

export function fadeInAnimation(element: Element): void {
    if (element.classList.contains(FADE_OUT)) {
        element.classList.remove(FADE_OUT);
    }
    animate(element, FADE_IN, false);
}

export function fadeOutAnimation(element: Element): void {
    if (element.classList.contains(FADE_IN)) {
        element.classList.remove(FADE_IN);
    }
    animate(element, FADE_OUT, false);
}

export function animate(element: Element, animation: string, removeAnimationClass = true): void {
    element.classList.add('animated', animation);

    const events: string[] = ['transitionend', 'animationend'];
    events.forEach((event: string) => {
        element.addEventListener(
            event,
            () => {
                element.classList.remove('animated');
                if (removeAnimationClass) {
                    element.classList.remove(animation);
                }
            },
            { once: true }
        );
    });
}
